var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import { Grid } from "react-bootstrap";
import { connect } from "react-redux";
import { get } from "lodash";
import idHelper from "@irati/utils/id";
import authentication from "@irati/auth";
import TenantHomePageQuery from "@irati/homepage/services/apollo/queries/TenantHomePage";
import Loading from "@irati/ui/src/Loading";
import PerkboxTour from "@irati-web/tour";
import OnboardingService from "@irati/onboarding/services/onboarding";
import OnboardingStep from "@irati/onboarding/enums/Step";
import { hangPromise } from "@irati/utils/promise";
import "@irati/deals/services/favourites";
import Layout from "../components/NewHomePage/ManageLayout/Layout";
import { HomePageView } from "../components/NewHomePage/types";
import HomePagePopTart from "../components/NewHomePage/HomePagePopTart";
import HomePageHeader from "../components/NewHomePage/Header";
import homepageTourSteps from "../tour";
var HomePageV2 = /** @class */ (function (_super) {
    __extends(HomePageV2, _super);
    function HomePageV2() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            pageView: _this.props.isMobile ? HomePageView.EMPLOYEE_VIEW : HomePageView.EDIT_CONTENT_VIEW,
            showPreview: true,
            tourSteps: homepageTourSteps,
            tenantEligibleForTour: false,
            userEligibleForTour: false,
            loadOnboardingData: hangPromise()
        };
        _this.onChangePreview = function () {
            _this.setState({ showPreview: !_this.state.showPreview });
        };
        _this.handleCompleteTour = function () {
            OnboardingService.completeStep(authentication.user(), OnboardingStep.HAS_COMPLETED_HOMEPAGE_TOUR);
        };
        return _this;
    }
    HomePageV2.prototype.componentDidMount = function () {
        var _this = this;
        var loadTenantOnboarding = OnboardingService.getTenantOnboarding()
            .then(function (tenantOnboarding) {
            if (!tenantOnboarding || !(tenantOnboarding === null || tenantOnboarding === void 0 ? void 0 : tenantOnboarding.enabled)) {
                _this.setState({
                    tenantEligibleForTour: true
                });
            }
        });
        var promises = [loadTenantOnboarding];
        if (!authentication.isUserGhost()) {
            var loadUserOnboarding = OnboardingService.get(authentication.user().uuid)
                .then(function (_a) {
                var completedSteps = _a.completedSteps;
                if (!completedSteps.includes(OnboardingStep.HAS_COMPLETED_HOMEPAGE_TOUR)) {
                    _this.setState({
                        userEligibleForTour: true
                    });
                }
            });
            promises.push(loadUserOnboarding);
        }
        this.setState({
            loadOnboardingData: Promise.all(promises)
        });
    };
    HomePageV2.prototype.render = function () {
        var _this = this;
        var isMobile = this.props.isMobile;
        var _a = this.state, tourSteps = _a.tourSteps, loadOnboardingData = _a.loadOnboardingData, tenantEligibleForTour = _a.tenantEligibleForTour, userEligibleForTour = _a.userEligibleForTour, showPreview = _a.showPreview;
        var canEdit = authentication.apps("platform.cultureHub.update");
        var getTenantHomePageVars = {
            isNative: false,
            tenantId: authentication.userTenant().uuid
        };
        var idNamespace = idHelper("HomePage", {});
        return (React.createElement(React.Fragment, null,
            !isMobile && canEdit && React.createElement(HomePagePopTart, { show: !showPreview, id: idNamespace, onExit: this.onChangePreview }),
            React.createElement(Grid, null,
                !isMobile && canEdit && (React.createElement(HomePageHeader, { onChangePreview: this.onChangePreview, id: idNamespace, showPreview: showPreview })),
                React.createElement(TenantHomePageQuery, { variables: getTenantHomePageVars }, function (_a) {
                    var data = _a.data;
                    return (React.createElement(Loading, { load: loadOnboardingData },
                        React.createElement(PerkboxTour, { run: tenantEligibleForTour && userEligibleForTour && canEdit, steps: tourSteps, onComplete: _this.handleCompleteTour }),
                        React.createElement(Layout, { companyNews: data.companyNews, id: idNamespace, isAdmin: canEdit && showPreview, layoutWidgets: data.layoutWidgets, pageView: HomePageView.EMPLOYEE_VIEW })));
                }))));
    };
    return HomePageV2;
}(Component));
var mapStateToProps = function (_a) {
    var mq = _a.mq;
    return {
        isMobile: get(mq, "lessThan.medium", false)
    };
};
export default connect(mapStateToProps)(HomePageV2);
